<div class="relative rounded-[10px] bg-malou-white shadow-malou">
    <div class="absolute left-0 top-0 h-[4px] w-full overflow-hidden">
        <div
            class="progress-bar--{{ duration() }} h-[200px] w-full rounded-[10px]"
            [ngClass]="{
                'bg-malou-state-success': type() === ToastVariant.SUCCESS,
                'bg-malou-state-warn': type() === ToastVariant.WARN,
                'bg-malou-state-error': type() === ToastVariant.ERROR,
            }"></div>
    </div>
    <div class="malou-toast__close" (click)="onClick()">
        <mat-icon color="primary" [svgIcon]="SvgIcon.CROSS"></mat-icon>
    </div>
    <div class="malou-toast__content items-center">
        <div class="malou-toast__content-prefix grid place-items-center">
            <ng-container [ngTemplateOutlet]="circleTemplate"></ng-container>
        </div>
        <div class="malou-toast__message break-word pl-4" [innerHTML]="message()"></div>
    </div>
</div>

<ng-template #circleTemplate>
    <div
        class="grid h-[45px] w-[45px] place-items-center rounded-full bg-opacity-40"
        [ngClass]="{
            'bg-malou-state-success': type() === ToastVariant.SUCCESS,
            'bg-malou-state-warn': type() === ToastVariant.WARN,
            'bg-malou-state-error': type() === ToastVariant.ERROR,
        }">
        <div
            class="grid h-[35px] w-[35px] place-items-center rounded-full"
            [ngClass]="{
                'bg-malou-state-success': type() === ToastVariant.SUCCESS,
                'bg-malou-state-warn': type() === ToastVariant.WARN,
                'bg-malou-state-error': type() === ToastVariant.ERROR,
            }">
            <mat-icon class="!h-[22px] !w-[22px] text-white" [svgIcon]="svgIcon"></mat-icon>
        </div>
    </div>
</ng-template>
